<div class="bg-slate-50 font-sans text-slate-900">
  <section
    class="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden"
  >
    <div
      class="p-5 border-b border-slate-100 flex items-center justify-between bg-slate-50/50"
    >
      <h2 class="font-semibold text-slate-800 m-0">Items</h2>
      <div class="flex items-center gap-3">
        <span
          class="text-[10px] font-bold text-slate-400 uppercase tracking-wider"
          >Drag to reorder</span
        >
        <!-- <button
          type="button"
          (click)="openListCreateModal()"
          class="text-[10px] font-bold tracking-wider uppercase cursor-pointer text-slate-800 bg-white border rounded-xl border-slate-300 px-2 py-1 rounded"
        >
          Add list
        </button> -->

        <!-- <span
          class="text-xs font-medium text-slate-500 bg-white border border-slate-200 px-2 py-1 rounded"
          >Q3 List</span
        > -->

        <lib-item-selector
          [es_entityName]="es_entityName()"
          [listName]="listName"
        ></lib-item-selector>
      </div>
    </div>

    <!-- Scenirio list not chosen -->
    <!-- <div
      class="bg-slate-100/60 p-3 px-5 text-sm text-slate-600 border-b border-slate-100 flex items-center gap-2"
    >
      <lucide-angular
        [img]="InfoIcon"
        class="w-4 h-4 text-slate-400"
      ></lucide-angular>
      <span
        >This list is used in 3 places.
        <span class="font-medium underline decoration-slate-300"
          >Edit with care.</span
        ></span
      >
    </div> -->

    @switch (store.activeList()?.list_type) { 
      @case (listType.NORMAL_LIST) {
        <lib-list-option-manager
          #listOptionManagerRef
          [activeListId]="store.activeListId()"
        ></lib-list-option-manager>
     } @case (listType.CONSTRUCTED_LIST) {
        <lib-dynamic-list-preview
        [displayNames]="dynamicPreviewItems()"
        ></lib-dynamic-list-preview>
      }
    }
  </section>
</div>
